<ion-card>
    <ion-card-content (click)="display = !display">
        <ion-label *ngIf="!display">See Order Lines</ion-label>
        <ion-label *ngIf="display">Hide Order Lines</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="display" no-padding>
        <ion-grid padding-horizontal>
            <ion-row>
                <ion-col size="6">
                    Product
                </ion-col>
                <ion-col size="3" text-center>
                    Ordered
                </ion-col>
                <ion-col size="3" text-center>
                    On site
                </ion-col>
            </ion-row>
            <ion-row *ngFor="let line of orderLines; index as i" (click)="addDetailLine(line)">
                <ion-col size="6">
                    {{line.description}}
                </ion-col>
                <ion-col size="3" text-center>
                    {{line.qty}}
                </ion-col>
                <ion-col size="3" text-center>
                    {{findQty(line.pdesc)}}
                </ion-col>
            </ion-row>
        </ion-grid>

    </ion-card-content>
</ion-card>
